import { Link } from "react-router-dom";

export const FanPage = () => {
	return (
		<div className="mx-auto my-auto justify-center w-full sm:w-1/3">
			<hr />
			<div className="px-auto py-auto text-lg font-serif leading-loose text-justify">
				Competition for the best athletes is getting hotter, but now you can
				help your team attract top talent by showing your love through NILO.
				Today, large-wealth donors have undue influence on the top talent. With
				NILO, the power of the entire fan base can be used to level the playing
				field. Send sponsorships directly to the athletes on your favorite
				teams, improving athlete retention and attracting higher quality talent.
				Or provide sponsorships to athletes to nudge them away from rival teams.
				And share the love by rewarding unimaginable moments in athletics.
			</div>
			<div className="my-12 py-auto text-lg font-serif leading-loose text-blue-600 font-bold underline">
				<Link to="/Sport">Find your favorite teams here</Link>
			</div>
		</div>
	);
};

export const AthletePage = () => {
	return (
		<div className="mx-auto my-auto justify-center w-full sm:w-1/3">
			<div className="px-auto py-auto text-lg font-serif leading-loose text-justify">
				Name, Image, and Likeness policy changes enable athletes to monetize
				their brand, but managing those contracts can be tricky and time
				consuming. By creating a non-exclusive NIL relationship with NILO, you
				can receive endorsements from thousands of fans, without having to work
				with each one individually. NILO protects players' amateur status while
				requiring very lightweight brand engagement, letting student athletes do
				what they do best - perform on the field and in the classroom.
			</div>
		</div>
	);
};

export const ProgramPage = () => {
	return (
		<div className="mx-auto my-auto justify-center w-full sm:w-1/3">
			<div className="px-auto py-auto text-lg font-serif leading-loose text-justify">
				Changes in NIL regulations have the opportunity to revolutionize player
				acquisition and retention. Some fans have already gone down the NIL
				collective route, and that has led to an imbalance in college
				recruitment - that directly impacts competitiveness, the likelihood of
				winning championships, and athletic program revenue. NILO provides an
				alternative route for influencing athlete decisions, enabling athletic
				programs to leverage the power of their fan base and leveling the
				playing field across college athletics.
			</div>
		</div>
	);
};
